/**
 * Derives a deterministic gradient rotation angle from a string.
 * Produces a value between 0 and 360 based on the string's character codes.
 */
export function gradientAngle(seed: string): number {
  let hash = 0;
  for (let i = 0; i < seed.length; i++) {
    hash = (hash * 31 + seed.charCodeAt(i)) | 0;
  }
  return Math.abs(hash) % 360;
}
